import React, { useState } from 'react';

export default function SettingsPanel({ options, setOptions, open, setOpen }) {
  const [showAdv, setShowAdv] = useState(false);

  const setBool = name => e => {
    const { checked } = e.target;
    setOptions(prev => ({ ...prev, [name]: checked }));
  };

  const setNum = name => e => {
    const { value } = e.target;
    setOptions(prev => ({ ...prev, [name]: Number(value) }));
  };

  const setStr = name => e => {
    const { value } = e.target;
    setOptions(prev => ({ ...prev, [name]: value }));
  };


  return (
    <div className={`settings-panel${open ? ' open' : ''}`}>
      <div className="settings-content">
        <div className="user-header">User Settings</div>
        <label>
          Verbose
          <span className="toggle-switch">
            <input type="checkbox" name="verbose" checked={options.verbose} onChange={setBool('verbose')} />
            <span className="toggle-slider" />
          </span>
        </label>
        <label>
          EV profiles
          <span className="toggle-switch">
            <input type="checkbox" name="evProfiles" checked={options.evProfiles} onChange={setBool('evProfiles')} />
            <span className="toggle-slider" />
          </span>
        </label>
        <label>
          HP profiles
          <span className="toggle-switch">
            <input type="checkbox" name="hpProfiles" checked={options.hpProfiles} onChange={setBool('hpProfiles')} />
            <span className="toggle-slider" />
          </span>
        </label>
        <label>
          PV profiles
          <span className="toggle-switch">
            <input type="checkbox" name="includePvProfiles" checked={options.includePvProfiles} onChange={setBool('includePvProfiles')} />
            <span className="toggle-slider" />
          </span>
        </label>
        <label>
          Timestep
          <select
            name="timestep"
            value={options.timestep}
            onChange={setStr('timestep')}
          >
            <option value="15min">15 min</option>
            <option value="hourly">Hourly</option>
            <option value="daily">Daily</option>
            <option value="day-night">Day / Night</option>
          </select>
        </label>
        <label>
          Voltage threshold
          <input type="number" name="voltageThreshold" value={options.voltageThreshold} step={0.01} onChange={setNum('voltageThreshold')} />
        </label>
        <div className="adv-header" onClick={() => setShowAdv(!showAdv)}>
          Advanced Settings {showAdv ? '\u25B2' : '\u25BC'}
        </div>
        {showAdv && (
          <div className="adv-options">
            <label>
              Std height
              <input type="number" name="stdHeight" value={options.stdHeight} step={0.1} onChange={setNum('stdHeight')} />
            </label>
            <label>
              Std surface threshold
              <input type="number" name="stdSurfaceThreshold" value={options.stdSurfaceThreshold} step={1} onChange={setNum('stdSurfaceThreshold')} />
            </label>
            <label>
              Load connecting tolerance
              <input type="number" name="loadConnectingTolerance" value={options.loadConnectingTolerance} step={1} onChange={setNum('loadConnectingTolerance')} />
            </label>
            <label>
              EBU-MV distance tolerance
              <input type="number" name="ebuMvDistanceTolerance" value={options.ebuMvDistanceTolerance} step={1} onChange={setNum('ebuMvDistanceTolerance')} />
            </label>
            <label>
              Line length threshold
              <input type="number" name="lineLengthThreshold" value={options.lineLengthThreshold} step={1} onChange={setNum('lineLengthThreshold')} />
            </label>
            <label>
              Standard line length
              <input type="number" name="standardLineLength" value={options.standardLineLength} step={1} onChange={setNum('standardLineLength')} />
            </label>
            <label>
              Leaf node connection
              <input type="number" name="leafNodeConnection" value={options.leafNodeConnection} step={1} onChange={setNum('leafNodeConnection')} />
            </label>
            <label>
              LV/MV load separation
              <input type="number" name="lvMvLoadSeparation" value={options.lvMvLoadSeparation} step={1} onChange={setNum('lvMvLoadSeparation')} />
            </label>
            <label>
              Simultaneity factor
              <input type="number" name="simultaneityFactor" value={options.simultaneityFactor} step={0.01} onChange={setNum('simultaneityFactor')} />
            </label>
            <label>
              LV trafo threshold
              <input type="number" name="lvTrafoThreshold" value={options.lvTrafoThreshold} step={0.1} onChange={setNum('lvTrafoThreshold')} />
            </label>
            <label>
              Power factor
              <input type="number" name="powerFactor" value={options.powerFactor} step={0.01} onChange={setNum('powerFactor')} />
            </label>
            <label>
              Panel efficiency
              <input type="number" name="panelEfficiency" value={options.panelEfficiency} step={0.1} onChange={setNum('panelEfficiency')} />
            </label>
            <label>
              Packing factor
              <input type="number" name="packingFactor" value={options.packingFactor} step={0.1} onChange={setNum('packingFactor')} />
            </label>
            <label>
              Person energy factor
              <input type="number" name="personEnergyFactor" value={options.personEnergyFactor} step={1} onChange={setNum('personEnergyFactor')} />
            </label>
            <label>
              Extra person energy factor
              <input type="number" name="stdExtraPersonEnergyFactor" value={options.stdExtraPersonEnergyFactor} step={1} onChange={setNum('stdExtraPersonEnergyFactor')} />
            </label>
            <label>
              Surface energy factor
              <input type="number" name="surfaceEnergyFactor" value={options.surfaceEnergyFactor} step={0.1} onChange={setNum('surfaceEnergyFactor')} />
            </label>
            <label>
              H profile tolerance
              <input type="number" name="hProfileTolerance" value={options.hProfileTolerance} step={1} onChange={setNum('hProfileTolerance')} />
            </label>
            <label>
              Overshoot
              <input type="number" name="overshoot" value={options.overshoot} step={0.01} onChange={setNum('overshoot')} />
            </label>
            <label>
              Intermediate print
              <span className="toggle-switch">
                <input type="checkbox" name="intermediatePrint" checked={options.intermediatePrint} onChange={setBool('intermediatePrint')} />
                <span className="toggle-slider" />
              </span>
            </label>
            <label>
              Intermediate results
              <span className="toggle-switch">
                <input type="checkbox" name="intermediateResults" checked={options.intermediateResults} onChange={setBool('intermediateResults')} />
                <span className="toggle-slider" />
              </span>
            </label>
            <label>
              Graph model
              <span className="toggle-switch">
                <input type="checkbox" name="graphModel" checked={options.graphModel} onChange={setBool('graphModel')} />
                <span className="toggle-slider" />
              </span>
            </label>
            <label>
              Power factory model
              <span className="toggle-switch">
                <input type="checkbox" name="powerFactoryModel" checked={options.powerFactoryModel} onChange={setBool('powerFactoryModel')} />
                <span className="toggle-slider" />
              </span>
            </label>
            <label>
              Max valid penalty
              <input type="number" name="maxValidPenalty" value={options.maxValidPenalty} step={1} onChange={setNum('maxValidPenalty')} />
            </label>
            <label>
              Community buffer
              <input type="number" name="communityBuffer" value={options.communityBuffer} step={1} onChange={setNum('communityBuffer')} />
            </label>
            <label>
              Tolerance
              <input type="number" name="tolerance" value={options.tolerance} step={0.001} onChange={setNum('tolerance')} />
            </label>
            <label>
              Max iterations
              <input type="number" name="maxIterations" value={options.maxIterations} step={1} onChange={setNum('maxIterations')} />
            </label>
            <label>
              GA size
              <input type="number" name="genSize" value={options.genSize} step={1} onChange={setNum('genSize')} />
            </label>
            <label>
              Penalty weight
              <input type="number" name="penaltyWeight" value={options.penaltyWeight} step={1} onChange={setNum('penaltyWeight')} />
            </label>
          </div>
        )}
      </div>
      <div className="settings-arrow" onClick={() => setOpen(!open)}>
        {open ? '\u25C0' : '\u25B6'}
      </div>
    </div>
  );
}
